import React, { useState, useEffect } from 'react';
import {
  Routes,
  Route,
  Link,
  useLocation
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import logo from './assets/logo.svg';
import QRModal from './components/qr-modal';
import Aboutus from './pages/aboutus';
import Contactus from './pages/contactus';
import Home from './pages/home';
import FAQ from './pages/faq';
// import Logout from './pages/logout';
import TermsAndConditions from './pages/terms_and_conditions';
// import Register from './pages/register';
// import Login from './pages/login';
import Disclaimer from './pages/disclaimer';
import Blogs from './pages/blogs/blogs';
import HomeCookedFood from './pages/blogs/home-cooked-food-benefits';
import TraditionalIndianFood from './pages/blogs/traditional-indian-food-never-out-of-style';
import FreshnessAndHygiene from './pages/blogs/freshness-and-hygiene';
import HomeCookedFoodForStudent from './pages/blogs/perfect-for-students';
import FromKitchenToHome from './pages/blogs/from-our-kitchen-to-your-heart-just-like-home';
import VegFoodBenefits from './pages/blogs/benefits-of-pure-veg-food';
import Loader from './components/loader';
import Cart from './pages/cart';
import MakePayment from './pages/make_payment';
import DeliveryAddress from './pages/delivery_address';
import PrivacyPolicy from './pages/privacy_policy';
import SpecialMenu from './pages/special_menu';
import Refresh from './pages/refresh';
import AdminHome from './pages/admin/home';
import AddUser from './pages/admin/addUser';
import EditUser from './pages/admin/editUser';
import WhatWeOffer from './pages/what-we-offer';
import OurFoodMenu from './pages/our-food-menu';
import OrderFood from './pages/order_food';
import PageNotFound from './pages/page-not-found';
import { getDeviceType, getUserName, getCustomerRole } from './utils/common';
// import { checkUserIsAuthAction } from './redux_files/actions/users_actions';
import Footer from './components/footer';

export const Menu = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [role, setRole] = useState(undefined);
  const [deviceType, setDeviceType] = useState(getDeviceType());
  const [showQrModal, setShowQrModal] = useState(false);
  const loggedInUserDetails = useSelector(state => state?.usersReducer?.loggedInUserDetails);
  const pageTitle = useSelector(state => state?.pageReducer?.pageTitle);
  const userName = getUserName(loggedInUserDetails);
  const customerRole = getCustomerRole(loggedInUserDetails);

  // const dispatch = useDispatch();
  const handleResize = () => {
    if (window.innerWidth < 600 && isNavOpen) setIsNavOpen(false);
    setDeviceType(getDeviceType());
  }
  useEffect(() => {
    setRole(customerRole);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isNavOpen]);

  // useEffect(() => {
  //   if(userName) dispatch(checkUserIsAuthAction());
  // },[]);

  const location = useLocation();

  useEffect(() => {
    setIsNavOpen(false);
  }, [location]);

  const loaderState = useSelector(state => state?.loader?.showHideLoaderInState) ?? false;
  const menuItems = [
    { link: "/", label: "Home" },
    { label: "Scan QR Code", action: () => setShowQrModal(true), isAction: true },
    { link: "/aboutus", label: "About Us" },
    { link: "/contactus", label: "Contact Us" },
    { link: "/blogs", label: "Blogs" },
    { link: "/faq", label: "Frequently asked questions" },
    { link: "/what-we-offer", label: "What we Offer" },
    { link: "/terms", label: "Terms and Conditions" },
    { link: "/privacy", label: "Privacy Policy" },
    { link: "/disclaimer", label: "Disclaimer" }
  ]
  return <div className='app-shell'>
    <div className='sticky-div'>
      <div className='main-div'>
        <div className='col align-to-left mt-10'>
          <Link to='/'>
            <img src={logo} alt='Shivay Durga' width={deviceType === 'mobile' ? 80 : 100} />
          </Link>
        </div>
        <div className={`col-2 align-to-center ${deviceType === 'mobile' ? 'page-title-mobile' : 'page-title'}`}>{pageTitle}</div>
        <div className='col align-to-right'>
          <div onClick={() => setIsNavOpen(!isNavOpen)} className={'menu_icon_div right-float'}>
            <div className='menu_icon'></div>
            <div className='menu_icon'></div>
            <div className='menu_icon'></div>
          </div>
        </div>
      </div>
    </div>
    <nav className={`nav ${isNavOpen ? 'nav-open' : 'nav-closed'}`}>
      <div className='row ml-10 mb-10'>
        {userName && (<div className='col wd-70 display-flex'><div className='text-white text-size-18 text-bold pd-l-16'>Hi {userName}</div></div>)}
        <div className={`col display-flex ${userName ? 'wd-20' : 'wd-100'}`}><div className='close_icon' onClick={() => setIsNavOpen(!isNavOpen)}>X</div></div>
      </div>
      <ul>
        {
          menuItems.map((item, index) => (
            <li key={index}>
              {item.isAction ? (
                <button
                  className="li_text qr-button"
                  onClick={() => {
                    item.action();
                    setIsNavOpen(false);
                  }}
                >
                  {item.label}
                </button>
              ) : (
                <Link to={item.link} className={pageTitle?.toLowerCase() === item.label.toLowerCase() ? "li_text_active" : "li_text"}>
                  {item.label}
                </Link>
              )}
            </li>
          ))
        }
        {
          userName ? (
            <>
            {role === "admin" && (
              <li>
                <Link to='/admin' className='li_text'>Admin</Link>
              </li>
            )}
              <li>
                <Link to='/logout' className='li_text'>Logout</Link>
              </li>
            </>
          ) : (
            <>
              {/* <li>
                <Link to='/login' className='li_text'>Login</Link>
              </li>
              <li>
                <Link to='/register' className='li_text'>Register</Link>
              </li> */}
            </>
          )
        }
      </ul>
    </nav>

      <div className='app-content'>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/aboutus' element={<Aboutus />} />
          <Route path='/contactus' element={<Contactus />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/home-cooked-food-benefits' element={<HomeCookedFood />} />
          <Route path='/traditional-indian-food-never-out-of-style' element={<TraditionalIndianFood />} />
          <Route path='/freshness-and-hygiene' element={<FreshnessAndHygiene />} />
          <Route path='/perfect-for-students' element={<HomeCookedFoodForStudent />} />
          <Route path='/from-our-kitchen-to-your-heart-just-like-home' element={<FromKitchenToHome />} />
          <Route path='/benefits-of-pure-veg-food' element={<VegFoodBenefits />} />
          <Route path='/terms' element={<TermsAndConditions />} />
          <Route path='/disclaimer' element={<Disclaimer />} />
          <Route path='/faq' element={<FAQ />} />
          <Route path='/what-we-offer' element={<WhatWeOffer />} />
          <Route path='/privacy' element={<PrivacyPolicy />} />
          <Route path='/special-menu' element={<SpecialMenu />} />
          <Route path='/our-food-menu' element={<OurFoodMenu />} />
          <Route path='/order-food' element={<OrderFood />} />
          {/* <Route path='/login' element={<Login />} />
          <Route path='/logout' element={<Logout />} /> */}
          <Route path='/refresh' element={<Refresh />} />
          {/* <Route path='/register' element={loaderState ? <Loader showOrHideLoader={loaderState} /> : <Register />} /> */}
          {
            userName !== undefined && (
              <>
                <Route path='/admin' element={loaderState ? <Loader showOrHideLoader={loaderState} /> : <AdminHome />} />
                <Route path='/adduser' element={loaderState ? <Loader showOrHideLoader={loaderState} /> : <AddUser />} />
                <Route path='/edituser' element={loaderState ? <Loader showOrHideLoader={loaderState} /> : <EditUser />} />
                <Route path='/cart' element={loaderState ? <Loader showOrHideLoader={loaderState} /> : <Cart />} />
                <Route path='/deliveryAddress' element={loaderState ? <Loader showOrHideLoader={loaderState} /> : <DeliveryAddress />} />
                <Route path='/makepayment' element={loaderState ? <Loader showOrHideLoader={loaderState} /> : <MakePayment />} />
              </>
            )
          }
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
      <Footer />
      <QRModal isOpen={showQrModal} onClose={() => setShowQrModal(false)} />
  </div>
}
